//namespace Pacem.Logging {
export var LogLevel;
(function (LogLevel) {
    LogLevel["Trace"] = "trace";
    LogLevel["Debug"] = "debug";
    LogLevel["Warn"] = "warn";
    LogLevel["Error"] = "error";
    LogLevel["Info"] = "info";
    LogLevel["Log"] = "log";
})(LogLevel || (LogLevel = {}));
//}
